import React, { useState } from "react";
import { useCreateWorkoutContainerMutation } from "../../libs/workout/api";
import { Modal } from "../Modal";
import { SubmitButton } from "../Button";
import { ColorPicker, DEFAULT_CONTAINER_COLOR } from "../ProgressionsTable/ColorPicker";

type Props = {
  openModal: string | undefined;
  setOpenModal: (modal: string | undefined) => void;
  /** null = cartella di primo livello; valorizzato = sotto-cartella. */
  parentId: number | null;
};

export const CreateWorkoutContainerModal: React.FC<Props> = ({
  openModal,
  setOpenModal,
  parentId,
}) => {
  const [name, setName] = useState("");
  const [color, setColor] = useState(DEFAULT_CONTAINER_COLOR);
  const [createContainer, { isLoading, error }] =
    useCreateWorkoutContainerMutation();

  const isSub = parentId != null;

  const reset = () => {
    setName("");
    setColor(DEFAULT_CONTAINER_COLOR);
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    createContainer({ name: name.trim(), color, parentId })
      .unwrap()
      .then(() => {
        reset();
        setOpenModal(undefined);
      })
      .catch(() => {});
  };

  return (
    <Modal
      title={isSub ? "Nuova sotto-cartella" : "Nuova cartella"}
      openModal={openModal === "createWorkoutContainer" ? "createWorkoutContainer" : undefined}
      setOpenModal={(v) => {
        setOpenModal(v);
        if (!v) reset();
      }}
    >
      {openModal === "createWorkoutContainer" && (
        <form onSubmit={onSubmit} className="flex flex-col gap-4">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">
              Nome {isSub ? "sotto-cartella" : "cartella"}
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={isSub ? "Es. Uomo" : "Es. Bulk"}
              className="block w-full py-2 px-4 text-sm text-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 focus:ring-blue-500 focus:border-blue-500"
              autoFocus
            />
          </div>
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              Colore
            </label>
            <ColorPicker value={color} onChange={setColor} />
          </div>
          <SubmitButton isPending={isLoading}>
            {isSub ? "Crea sotto-cartella" : "Crea cartella"}
          </SubmitButton>
          {error && (
            <p className="text-sm text-red-600">Errore durante la creazione.</p>
          )}
        </form>
      )}
    </Modal>
  );
};
